'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESPONSE_ERROR = exports.USER_ERROR = exports.BOARD_ERROR = exports.ERROR_CLEAR = exports.ERROR_THROW = undefined;

var _httpConstants = require('../utils/http/httpConstants');

var ERROR_THROW = exports.ERROR_THROW = 'ERROR_THROW'; // Constants
var ERROR_CLEAR = exports.ERROR_CLEAR = 'ERROR_CLEAR';

// boards
var BOARD_ERROR = exports.BOARD_ERROR = {
    GENERIC_ERROR: 'GENERIC_ERROR',
    NOT_FOUND: 'BOARD_NOT_FOUND',
    DELETED: 'BOARD_DELETED',
    ACCESS_DENIED: 'BOARD_ACCESS_DENIED',
    TIMEOUT: _httpConstants.ERROR_CODES.CONNECTION_ABORTED,
    CONNECTION_LOST: _httpConstants.ERROR_CODES.CONNECTION_RESET
};

var USER_ERROR = exports.USER_ERROR = {
    NOT_FOUND: 'USER_NOT_FOUND'
};

var RESPONSE_ERROR = exports.RESPONSE_ERROR = {
    VALIDATION_FAILURE: 'INVALID',
    NOT_ADMIN: 'NOT_ADMIN',
    BAD_REQUEST: 'BAD_REQUEST'
};


//////////////////
// WEBPACK FOOTER
// ./src/common/error/errorConstants.js
// module id = 243
// module chunks = 0